import { render, staticRenderFns } from "./order_management.vue?vue&type=template&id=f3489fcc&scoped=true&"
import script from "./order_management.vue?vue&type=script&lang=js&"
export * from "./order_management.vue?vue&type=script&lang=js&"
import style0 from "./order_management.vue?vue&type=style&index=0&id=f3489fcc&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f3489fcc",
  null
  
)

export default component.exports